import { Youtube } from "lucide-react";
import { Overline, Reveal, MaskLine, ArrowLink } from "./shared";
import { useLang } from "@/i18n";

const videos = [
  { id: "eMJa1KtSEjI", title: "How women of Sira Shakti Community Produces Cold Pressed Black Mustard Oil" },
  { id: "RhjvjQFA6WE", title: "How women of Sira Shakti Community Produces Wood Pressed Coconut Oil" },
  { id: "HrCN4x1TOZ8", title: "How women of Sira Shakti Community Produces Wood Pressed Yellow Mustard Oil" },
];

export default function Videos() {
  const { t } = useLang();
  const captions = t("videos.captions");

  return (
    <section id="films" className="bg-sand/60 py-24 lg:py-32" data-testid="videos-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <Overline>{t("videos.overline")}</Overline>
            <h2 className="mt-4 font-serif text-4xl font-medium leading-tight tracking-tight sm:text-5xl">
              <MaskLine>{t("videos.title1")}</MaskLine>
              <MaskLine delay={0.12}>
                <span className="italic text-olive">{t("videos.title2")}</span>
              </MaskLine>
            </h2>
          </div>
          <Reveal delay={0.2}>
            <ArrowLink href="https://www.youtube.com/@arnivedafarm" testId="youtube-channel-link">
              <span className="inline-flex items-center gap-2">
                <Youtube className="h-4 w-4" /> @arnivedafarm
              </span>
            </ArrowLink>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          {videos.map((v, i) => (
            <Reveal key={v.id} delay={i * 0.1} className={i === 1 ? "lg:mt-12" : ""}>
              <div className="group" data-testid={`youtube-video-${i + 1}`}>
                <div className="aspect-video overflow-hidden border border-ink/10 bg-ink">
                  <iframe
                    src={`https://www.youtube.com/embed/${v.id}?rel=0&modestbranding=1`}
                    title={v.title}
                    loading="lazy"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="h-full w-full"
                  />
                </div>
                <p className="mt-4 text-xs uppercase tracking-[0.18em] text-moss transition-colors duration-300 group-hover:text-terracotta">
                  {captions[i]}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-16">
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2" data-testid="films-photos">
            <div className="overflow-hidden border border-ink/10">
              <img
                src="/assets/farm/bottling-station.jpeg"
                alt="Hand bottling and packing station at the unit"
                className="aspect-[16/10] w-full object-cover transition-transform duration-700 ease-out hover:scale-105"
                loading="lazy"
              />
            </div>
            <div className="overflow-hidden border border-ink/10 sm:mt-10">
              <img
                src="/assets/farm/community-wide.jpeg"
                alt="The full Sira Shakti processing unit with both press machines"
                className="aspect-[16/10] w-full object-cover transition-transform duration-700 ease-out hover:scale-105"
                loading="lazy"
              />
            </div>
          </div>
          <p className="mt-4 text-xs uppercase tracking-[0.18em] text-moss">{t("extras.filmsCaption")}</p>
        </Reveal>
      </div>
    </section>
  );
}
